<template>
  <div>
    <div class="modal fade" id="register-delivery-info-modal" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-body">
            <h4 class="m-t-none m-b-none"><strong>発送元情報登録</strong></h4>
            <div class="form-register p-xl">
              <form>
                <div class="form-group">
                  <label for="name">名称（企業名、名前)</label>
                  <input type="text" v-model.trim="formRegisterData.name" class="form-control" id="name">
                </div>
                <div class="form-group">
                  <label for="postalcode">郵便番号</label>
                  <div class="row">
                    <div class="col-md-6">
                      <input type="text" v-model.trim="formRegisterData.postalcode" class="form-control" id="postalcode" placeholder="ハイフンなし">
                    </div>
                    <div class="col-md-6">
                      <button type="button" class="btn btn-primary custom-btn-delivery" @click.prevent="searchAddressByPostalCode()">住所検索</button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="address">住所</label>
                  <div class="box-input-address">
                    <input type="text" v-model.trim="formRegisterData.address" class="form-control" id="address" autocomplete="off" @input="handleChangeAddress()" @focus="handleFocusAddress()" @blur="handleBlurAddress()">
                    <div v-if="showAddressList" class="box-address-list">
                      <ul class="address-list list-group">
                        <a v-for="(address, addressIndex) in addressList" :key="addressIndex" href="javascript:void(0)" :class="['address-item list-group-item list-group-item-action', formRegisterData.address === address ? 'active' : '']" @click.prevent="chooseAddressItem(address)">{{ address }}</a>
                      </ul>
                    </div>
                  </div>
                  <div>※日本以外が発送元となる場合は、国名から入力してください</div>
                </div>
                <div class="form-group">
                  <label for="phone-number">電話番号</label>
                  <input type="text" v-model.trim="formRegisterData.phone_no" class="form-control" id="phone-number">
                </div>
                <div class="text-center m-t-lg">
                  <button type="button" class="btn btn-basic custom-btn-delivery m-r-sm" data-dismiss="modal" @click="$emit('close')">閉じる</button>
                  <button type="button" class="btn btn-warning custom-btn-delivery" :disabled="disabledSubmit" @click.prevent="handleSubmit()">{{ submitText }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryInfoSellerService from '@/services/deliveryinfosellerservice'
import store from '@/store'
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      loader: null,
      formRegisterData: {
        name: '',
        seq: '',
        postalcode: '',
        address: '',
        phone_no: ''
      },
      showAddressList: false,
      addressList: []
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      currentDeliveryInfoSeq: 'getCurrentDeliveryInfoSeq',
      selectedDeliveryInfoItem: 'getSelectedDeliveryInfoItem'
    }),
    submitText () {
      let text = '登録する'
      if (this.selectedDeliveryInfoItem && Object.keys(this.selectedDeliveryInfoItem).length) {
        text = '変更する'
      }
      return text
    },
    disabledSubmit () {
      return !(this.formRegisterData.name && this.formRegisterData.postalcode && this.formRegisterData.address && this.formRegisterData.phone_no)
    }
  },
  methods: {
    handleChangeAddress () {
      if (this.addressList.length) {
        this.showAddressList = true
      } else {
        this.showAddressList = false
      }
    },
    handleFocusAddress () {
      if (this.addressList.length) {
        this.showAddressList = true
      } else {
        this.showAddressList = false
      }
    },
    handleBlurAddress () {
      setTimeout(() => {
        this.showAddressList = false
      }, 400)
    },
    chooseAddressItem (address) {
      this.formRegisterData.address = address
      this.showAddressList = false
    },
    async searchAddressByPostalCode () {
      this.addressList = []
      this.loader = this.$loading.show()
      await DeliveryInfoSellerService.searchAddressByPostalCode({ postalcode: this.formRegisterData.postalcode })
        .then((response) => {
          this.loader && this.loader.hide()
          let results = response.data
          if (results && results.length) {
            this.formRegisterData.address = `${results[0]['address1']} ${results[0]['address2']} ${results[0]['address3']}`
            if (results.length === 1) {
              this.showAddressList = false
            } else {
              results.filter((item) => {
                this.addressList.push(`${item['address1']} ${item['address2']} ${item['address3']}`)
                this.showAddressList = true
              })
            }
          }
        })
        .catch((err) => {
          this.loader && this.loader.hide()
          store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    handleRegisterDeliveryInfo () {
      this.loader = this.$loading.show()
      this.formRegisterData.seq = this.currentDeliveryInfoSeq
      DeliveryInfoSellerService.create(this.formRegisterData)
        .then((response) => {
          store.commit('setDeliveryInfoItems', response.data)
          this.loader && this.loader.hide()
          this.$emit('close')
        })
        .catch((err) => {
          this.loader && this.loader.hide()
          store.commit('toggleModal', {
            show: true,
            message: err
          })
        })

      const name = this.type === 'Across' ? eventCode.warehouse_across.delivery_tab.direct_delivery.click_regis_shipping_info_btn : eventCode.delivery_requests.delivery_request_registration_tab.delivery_info.click_register_button
      let logParams = {
        name: name,
        properties: this.formRegisterData
      }
      EventService.postTrackLog(logParams)
    },
    handleUpdateDeliveryInfo () {
      this.loader = this.$loading.show()
      DeliveryInfoSellerService.update(this.formRegisterData)
        .then((response) => {
          store.commit('setDeliveryInfoItems', response.data)
          this.loader && this.loader.hide()
          this.$emit('close')
          this.$emit('updatedDeliveryInfo')
        })
        .catch((err) => {
          this.loader && this.loader.hide()
          store.commit('toggleModal', {
            show: true,
            message: err
          })
        })

      const name = this.type === 'Across' ? eventCode.warehouse_across.delivery_tab.direct_delivery.click_update_shipping_info_btn : eventCode.delivery_requests.delivery_request_registration_tab.delivery_info.click_change_button
      let logParams = {
        name: name,
        properties: {
          seq: this.formRegisterData.seq
        }
      }
      EventService.postTrackLog(logParams)
    },
    handleSubmit () {
      if (this.selectedDeliveryInfoItem && Object.keys(this.selectedDeliveryInfoItem).length) {
        this.handleUpdateDeliveryInfo()
      } else {
        this.handleRegisterDeliveryInfo()
      }
    },
    setFormRegisterData () {
      if (this.selectedDeliveryInfoItem && Object.keys(this.selectedDeliveryInfoItem).length) {
        this.formRegisterData.name = this.selectedDeliveryInfoItem.name
        this.formRegisterData.seq = this.selectedDeliveryInfoItem.seq
        this.formRegisterData.postalcode = this.selectedDeliveryInfoItem.postalCode
        this.formRegisterData.address = this.selectedDeliveryInfoItem.address
        this.formRegisterData.phone_no = this.selectedDeliveryInfoItem.phoneNo
      }
    }
  },
  mounted () {
    this.setFormRegisterData()
    $('#register-delivery-info-modal').modal('show')
    $('#register-delivery-info-modal').on('hidden.bs.modal', (e) => {
      if (!$('#delivery-info-modal').length) {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    })
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
    this.$emit('close')
    store.commit('setCurrentDeliveryInfoSeq', null)
    store.commit('setSelectedDeliveryInfoItem', null)
    $('.modal-backdrop').remove()
    setTimeout(() => {
      if (!$('#delivery-info-modal').length) {
        $('body').attr({
          style: null
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    }, 700)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/RegisterDeliveryInfoModal.vue